import {
  FETCH_ALL_DOCTORS,
  FETCH_ALL_DOCTORS_SUCCESS,
  FETCH_ALL_DOCTORS_FAILED,
  UPDATE_BROKER_SUCCESS,
} from "../store/types";

export const INITIAL_STATE = {
  users: null,
  loading: false,
  error: {
    flag: false,
    msg: null,
  },
};

export const Brokersreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_DOCTORS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_DOCTORS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      };
    case FETCH_ALL_DOCTORS_FAILED:
      return {
        ...state,
        users: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
      case UPDATE_BROKER_SUCCESS:
                  return {
                      ...state,
                      loading: false,
                      users: state.users.map((user) =>
                        user.email === action.payload.email
                              ? { ...user, ...action.payload }
                              : user
                      ),
                      error: null, 
                  };
    default:
      return state;
  }
};
